import { Box, Button, Divider, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import CustomTooltip from "../../../../../../components/CustomTooltip";
import {
  getPrettyDate,
  getReadableTime,
  useLocalTime,
} from "../../../../../../utils/timestamp";
import { DotAndLine } from "./DotAndLine";
import { RemediatedEntitiesChip } from "./RemediatedEntitiesChip";

export default function RemediationAuditLog({
  auditLog,
  onMoreDetails,
  showTopConnectLine = true,
  showBottomConnectLine = true,
}) {
  const colors = useColors();
  const showLocalTime = useLocalTime();

  const remediatedEntitiesCount = auditLog.remediated_entities
    ? auditLog.remediated_entities.reduce(
        (acc, g) =>
          acc +
          (g.affected_entities && g.affected_entities.length > 0
            ? g.affected_entities.length
            : 1),
        0
      )
    : 0;

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      gap={1}
      sx={{
        width: "100%",
        borderRadius: 12,
        height: 66,
      }}
    >
      {/* Date and time */}
      <Box
        textAlign="left"
        display="flex"
        flexDirection="column"
        minWidth={80}
        pb="10px"
      >
        <Typography variant="caption">
          {getReadableTime(auditLog.log_timestamp.timestamp_utc, showLocalTime)}
        </Typography>
        <Typography variant="caption" color={colors.text_secondary}>
          {getPrettyDate(auditLog.log_timestamp.timestamp_utc, showLocalTime)}
        </Typography>
      </Box>

      <DotAndLine
        showTop={showTopConnectLine}
        showBottom={showBottomConnectLine}
      />

      {/* User and entities */}
      <Box display="flex" flexDirection="row" width="100%" pb="10px">
        <Box
          display="flex"
          flexDirection="row"
          width="100%"
          gap={2}
          alignItems="center"
          padding="8px 16px 16px 16px"
          border="1px solid"
          borderRadius="12px"
          borderColor={colors.divider}
          sx={{ backgroundColor: colors.common_white }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body2" color={colors.text_secondary}>
              Applied by
            </Typography>
            <CustomTooltip title={auditLog.user_display_name}>
              <Typography
                variant="body2"
                noWrap
                sx={{
                  maxWidth: 150,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {auditLog.user_display_name}
              </Typography>
            </CustomTooltip>
          </Box>

          <Divider orientation="vertical" flexItem sx={{ height: 24, mt: 1 }} />
          <RemediatedEntitiesChip quantity={remediatedEntitiesCount} />

          <CustomTooltip title="View details of remediated entities">
            <Button
              variant="text"
              sx={{
                ml: "auto",
                color: colors.button_text_primary_enabled_text,
                backgroundColor: colors.button_text_primary_enabled_bg,
                borderRadius: "10px",
                minWidth: "64px",
                padding: "7px 14.5px",
                textTransform: "none",
                fontSize: "12px", // size XS
                "&:hover": {
                  backgroundColor: colors.button_text_primary_hovered_bg,
                },
              }}
              onClick={() => onMoreDetails(auditLog)}
            >
              More Details
            </Button>
          </CustomTooltip>
        </Box>
      </Box>
    </Box>
  );
}
